if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* ------------------------------------------------------------------------- */
/* BADCO 2026-08-29 - instant variant switching.                              */
/*                                                                            */
/* The problem: Dawn re-renders the entire main-product section on the server */
/* every time a shopper touches an option. On the harness page that section   */
/* is ~2,700 lines of Liquid, so the round trip is slow, and Dawn disables    */
/* Add to cart for the whole wait. A greyed-out button reads as "sold out",   */
/* and shoppers were abandoning before the response landed.                   */
/*                                                                            */
/* The fix: buy-buttons.liquid now embeds a small variant lookup table. On    */
/* every option change we resolve the variant in the browser and set the      */
/* variant id, the Add to cart button, the price, the fit hint, and the       */
/* unavailable-option marks immediately - no waiting. Dawn's fetch still runs */
/* and reconciles inventory, media and quantity rules when it returns; the    */
/* server stays the source of truth. If the lookup table is missing or the    */
/* combination cannot be resolved, we fall back to showing the button's       */
/* spinner so the wait at least looks deliberate.                             */
/*                                                                            */
/* Self-contained: subscribes to Dawn's own pub/sub events and modifies no    */
/* other theme JS. Deleting this block reverts to stock behaviour.            */
/* ------------------------------------------------------------------------- */
(function () {
  if (window.__badcoVariantFast) return;
  window.__badcoVariantFast = true;

  var FAILSAFE_MS = 10000;
  var spinnerTimer = null;

  function strings() {
    var s = window.variantStrings || {};
    return {
      addToCart: s.addToCart || 'Add to cart',
      soldOut: s.soldOut || 'Sold out',
      unavailable: s.unavailable || 'Unavailable',
    };
  }

  function readTable(info) {
    var node = info.querySelector('script.badco-variant-data');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      return Array.isArray(data) && data.length ? data : null;
    } catch (e) {
      return null;
    }
  }

  // Mirrors VariantSelects#selectedOptionValues, but by value text rather than
  // option-value id, so it can be matched straight against variant.options.
  function selectedValues(info) {
    var selects = info.querySelector('variant-selects');
    if (!selects) return null;
    var nodes = selects.querySelectorAll('select option[selected], fieldset input:checked');
    if (!nodes.length) return null;
    return Array.prototype.map.call(nodes, function (el) {
      return String(el.value == null ? '' : el.value).trim();
    });
  }

  function sameOptions(variant, values) {
    if (!variant.options || variant.options.length !== values.length) return false;
    for (var i = 0; i < values.length; i++) {
      if (String(variant.options[i]).trim() !== values[i]) return false;
    }
    return true;
  }

  function findVariant(table, values) {
    for (var i = 0; i < table.length; i++) {
      if (sameOptions(table[i], values)) return table[i];
    }
    return null;
  }

  // An option value is offerable if some AVAILABLE variant carries it while
  // every other option stays as the shopper currently has it.
  function valueIsOfferable(table, values, index, candidate) {
    for (var i = 0; i < table.length; i++) {
      var v = table[i];
      if (!v.available || !v.options || v.options.length !== values.length) continue;
      if (String(v.options[index]).trim() !== candidate) continue;
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (j !== index && String(v.options[j]).trim() !== values[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return true;
    }
    return false;
  }

  function markOptions(info, table, values) {
    var selects = info.querySelector('variant-selects');
    if (!selects) return;
    // Every picker type carries .product-form__input - pill and swatch groups
    // are fieldsets, dropdowns are a div - so selecting on that keeps group
    // order aligned with the order selectedValues() produced. Selecting on
    // 'fieldset' alone would mis-index a product that mixes picker types.
    var groups = selects.querySelectorAll('.product-form__input');
    Array.prototype.forEach.call(groups, function (group, index) {
      if (index >= values.length) return;
      var radios = group.querySelectorAll('input[type="radio"]');
      Array.prototype.forEach.call(radios, function (radio) {
        var candidate = String(radio.value == null ? '' : radio.value).trim();
        var unavailable = !valueIsOfferable(table, values, index, candidate);
        // The two picker types key off different classes: pill radios use
        // .disabled, swatch chips use .visually-disabled (see swatch-input
        // .liquid). Toggling only .disabled left colour chips stuck looking
        // crossed out until the server render replaced them.
        if (radio.classList.contains('swatch-input__input')) {
          radio.classList.toggle('visually-disabled', unavailable);
        } else {
          radio.classList.toggle('disabled', unavailable);
        }
      });
    });
  }

  // Mirrors the markup snippets/price.liquid produces. The container carries
  // price--on-sale / price--sold-out, and BOTH the regular and sale blocks are
  // always rendered - CSS decides which one shows. So update both, then set the
  // container classes.
  function setPrice(info, variant) {
    var box = info.querySelector('[id^="price-"]');
    if (!box) return;
    var wrap = box.querySelector('.price') || box;
    var regular = box.querySelector('.price__regular .price-item--regular');
    var saleNow = box.querySelector('.price__sale .price-item--sale');
    var saleWas = box.querySelector('.price__sale s.price-item--regular');
    if (!variant.price) return;
    if (regular) regular.textContent = variant.price;
    if (saleNow) saleNow.textContent = variant.price;
    if (saleWas && variant.cap) saleWas.textContent = variant.cap;
    wrap.classList.toggle('price--on-sale', !!variant.cap);
    wrap.classList.toggle('price--sold-out', variant.available === false);
  }

  function setButton(form, enabled, label) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;
    var span = button.querySelector('span');
    if (enabled) button.removeAttribute('disabled');
    else button.setAttribute('disabled', 'disabled');
    if (span && label) span.textContent = label;
  }

  function spinner(info, on) {
    var forms = (info || document).querySelectorAll('product-form');
    Array.prototype.forEach.call(forms, function (form) {
      var button = form.querySelector('[type="submit"]');
      if (!button) return;
      var el = button.querySelector('.loading__spinner') || form.querySelector('.loading__spinner');
      // `.loading` makes the label transparent, so without a spinner element
      // the button would just render blank. Leave it alone in that case.
      if (!el) return;
      button.classList.toggle('loading', on);
      el.classList.toggle('hidden', !on);
    });
  }

  function stopSpinner() {
    if (spinnerTimer) {
      clearTimeout(spinnerTimer);
      spinnerTimer = null;
    }
    spinner(document, false);
  }

  function startSpinner(info) {
    spinner(info, true);
    if (spinnerTimer) clearTimeout(spinnerTimer);
    spinnerTimer = setTimeout(stopSpinner, FAILSAFE_MS);
  }

  // Returns true when the variant was resolved in the browser.
  function applyInstant(info) {
    var table = readTable(info);
    var values = selectedValues(info);
    var form = info.querySelector('product-form');
    if (!table || !values || !form) return false;

    var idInput = form.querySelector('input[name="id"]');
    var variant = findVariant(table, values);
    var t = strings();

    markOptions(info, table, values);

    if (!variant) {
      if (idInput) idInput.value = '';
      setButton(form, false, t.unavailable);
      return true;
    }

    if (idInput) {
      idInput.disabled = false;
      idInput.value = variant.id;
    }
    setButton(form, variant.available, variant.available ? t.addToCart : t.soldOut);
    // Added 2026-08-29 after Drew caught Tri-FoldAway showing the L price while
    // XL was selected and the button was already live. Leaving price to the
    // server reconcile meant Add to cart could be clicked against a stale
    // figure, which is worse than the slow-but-consistent behaviour it replaced.
    setPrice(info, variant);
    // The fit-finder hint under the size pills ("XL fits: ...") is rendered by
    // product-info.js's own updateSizeHint(), which that file only calls once the
    // server render lands - so it lagged everything else by a full round trip.
    // It reads data-info off the checked radio, which is already in the DOM, so
    // calling it here is safe and needs no duplicated logic.
    if (typeof info.updateSizeHint === 'function') {
      try {
        info.updateSizeHint();
      } catch (e) {
        /* never let the hint break the buy button */
      }
    }
    return true;
  }

  // Dawn's own completion signal: product-info calls updateVariantInputs() on
  // every finished render, including the unavailable-combination path, and that
  // dispatches `change` on the hidden id input.
  document.addEventListener(
    'change',
    function (event) {
      var el = event.target;
      if (el && el.name === 'id' && el.closest && el.closest('product-form')) stopSpinner();
    },
    true
  );

  function wire() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      window.requestAnimationFrame(wire);
      return;
    }

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
      var target = payload && payload.data && payload.data.event && payload.data.event.target;
      var info = target && target.closest ? target.closest('product-info') : null;
      if (!info) return;
      // product-info disables the button synchronously in resetProductFormState.
      // A microtask runs after every synchronous subscriber but before the next
      // paint, so the shopper never sees the button flicker to disabled.
      var run = function () {
        if (!applyInstant(info)) startSpinner(info);
      };
      if (typeof queueMicrotask === 'function') queueMicrotask(run);
      else Promise.resolve().then(run);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, stopSpinner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
